/* eslint-disable no-shadow,no-param-reassign */

const initialState = {
  current: {
    id: null,
    logo: "",
    name: "",
    subdomain: "",
    locations: []
  },

  practices: [],
  pageCount: 1,
  currentPage: 1,

  users: {},

  showSwitcher: false,
  timezones: [],
  searchUsers: {},
  userSearchMessage: "",

  searchQuery: "",
  searchLoading: false
};

export const state = initialState;

export const getters = {
  current: state => state.current,
  get: state => id => state.practices[id],
  showSwitcher: state => state.showSwitcher,
  list: state => state.practices,
  sortedList: state => {
    let practices = state.practices;
    let practivesArr = [];
    for (var practiceId in practices) {
      practivesArr.push(practices[practiceId]);
    }
    practivesArr.sort((a, b) => {
      if (a.attributes.parentId == null && b.attributes.parentId != null) {
        return -1;
      } else {
        return 1;
      }
    });
    return practivesArr;
  },
  subdomain: state => state.current.subdomain,
  users: state => state.users,
  getUser: state => id => state.users[id],
  isHealeo: state => id =>
    state.practices[id].attributes.subdomain === "public",
  getTimezones: state => state.timezones,
  getSearchUsers: state => state.searchUsers,
  locations: state => state.current.locations,
  locationsArray: state => state.current.locations.map(l => l.location),
  currentPage: state => state.currentPage,
  pageCount: state => state.pageCount,
  searchQuery: state => state.searchQuery,
  searchLoading: state => state.searchLoading,
  userSearchMessage: state => state.userSearchMessage
};

export const actions = {
  set({ commit }, payload) {
    commit("set", payload);
  },

  setList({ commit }, payload) {
    commit("setList", payload);
  },

  update({ commit }, payload) {
    commit("update", payload);
  },

  add({ commit }, payload) {
    commit("add", payload);
  },

  remove({ commit }, payload) {
    commit("remove", payload);
  },

  toggleSwitcher({ commit }, payload) {
    commit("toggleSwitcher", payload);
  },

  switch({ commit }, payload) {
    commit("switch", payload);
  },

  setUsers({ commit }, payload) {
    commit("setUsers", payload);
  },

  updateUser({ commit }, payload) {
    commit("updateUser", payload);
  },

  addUser({ commit }, payload) {
    commit("addUser", payload);
  },

  removeUser({ commit }, payload) {
    commit("removeUser", payload);
  },

  reinstateUser({ commit }, payload) {
    commit("reinstateUser", payload);
  },

  setTimezones({ commit }, payload) {
    commit("setTimezones", payload);
  },

  userSearch({ commit }, payload) {
    commit("userSearch", payload);
  },

  setSearchQuery({ commit }, payload) {
    commit("setSearchQuery", payload);
  },

  setSearchLoading({ commit }, payload) {
    commit("setSearchLoading", payload);
  },

  setUserSearchMessage({ commit }, payload) {
    commit("setUserSearchMessage", payload);
  }
};

export const mutations = {
  set(state, practice) {
    state.current = practice;
  },

  setList(state, data) {
    state.practices = data.practices;

    let currentPage = 1;
    let pageCount = 1;

    if (data.links.self) {
      const current = data.links.self.match(/page%5Bnumber%5D=(\d+)&/);
      currentPage = current[1];
    }

    if (data.links.last) {
      const last = data.links.last.match(/page%5Bnumber%5D=(\d+)&/);
      pageCount = last[1];
    } else {
      pageCount = currentPage;
    }

    state.pageCount = pageCount;
    state.currentPage = currentPage;
  },

  update(state, practice) {
    state.practices = Object.assign(state.practices, practice);
    const updatedPractice = Object.values(practice);
    if (state.current.id === updatedPractice[0].id) {
      state.current = {
        id: updatedPractice[0].id,
        ...updatedPractice[0].attributes
      };
    }
  },

  add(state, practice) {
    state.practices = Object.assign(state.practices, practice);
  },

  remove(state, practice) {
    const practices = Object.assign({}, state.practices);
    delete practices[practice];
    state.practices = practices;
  },

  toggleSwitcher(state, show) {
    state.showSwitcher = show;
  },

  switch(state, id) {
    state.current = Object.assign({}, state.practices[id].attributes, { id });
  },

  setUsers(state, users) {
    state.users = users;
  },

  updateUser(state, user) {
    state.users = Object.assign(state.users, user);
  },

  addUser(state, user) {
    state.users = Object.assign({}, state.users, user);
  },

  removeUser(state, user) {
    const users = Object.assign({}, state.users);
    users[user].attributes.deletedAt = true;
    state.users = users;
  },

  reinstateUser(state, user) {
    const users = Object.assign({}, state.users);
    users[user].attributes.deletedAt = null;
    state.users = users;
  },

  setTimezones(state, zones) {
    state.timezones = zones;
  },

  userSearch(state, users) {
    state.searchUsers = users;
  },

  setSearchQuery(state, query) {
    state.searchQuery = query;
  },
  setSearchLoading(state, status) {
    state.searchLoading = status;
  },
  setUserSearchMessage(state, message) {
    state.userSearchMessage = message;
  }
};
